import {
  IonButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonIcon,
  IonPage,
  IonTitle,
  IonToolbar
} from "@ionic/react";
import { chevronBack } from "ionicons/icons";
import ProgressBar from "../components/ProgressBar";
import { useParams } from "react-router-dom";
import { useQuestsStore } from "../stores/quests.store";
import React, { useState } from "react";
import ProgressBarAlt from "../components/ProgressBarAlt";
import { useHistory } from "react-router";
import QuoQuestLevelSlider from "../components/QuoQuestLevelSlider";

const QuoQuestLevel = () => {
  const history = useHistory();
  const { levelId, stageIndex } = useParams<{
    levelId: string;
    stageIndex?: string;
  }>();
  const levels = useQuestsStore(state => state.levels);
  // Inner state changes aren't triggered by updateLevelStage in state as it modifies "levels" on state
  // We must therefore listen to levels on state and get derived level in the component
  const level = levels.find(lvl => lvl.level === +levelId);
  let lastStage = level?.stages.findIndex(stage => !stage.hasCleared);
  if (level && lastStage === -1) {
    lastStage = level.stages.length - 1;
  }
  const [stageIdx, setStageIdx] = useState(
    stageIndex ? +stageIndex : lastStage ?? 0
  );
  const handleSwipeChange = (activeSlideIndex: number) =>
    setStageIdx(activeSlideIndex);

  if (!level) {
    history.goBack();
  }
  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonButton onClick={() => history.goBack()}>
              <IonIcon className="text-white" icon={chevronBack} />
            </IonButton>
          </IonButtons>
          <IonTitle className="capitalize font-normal pt-4">
            Quest {levelId}: {level?.levelName}
          </IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen>
        {level && level.stages && (
          <div className="flex flex-col h-full pt-6">
            <ProgressBarAlt
              percent={level.completionPercent}
              className="mx-auto"
            />
            <QuoQuestLevelSlider
              level={level.level}
              stages={level.stages}
              onSwipe={handleSwipeChange}
              currentSlide={stageIdx}
            />
            <ProgressBar
              activePage={stageIdx}
              pageCount={level.stages.length - 1}
            />
          </div>
        )}
      </IonContent>
    </IonPage>
  );
};
export default QuoQuestLevel;
